/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../../apiResponse';
import { createApiResponseSchema } from '../../../apiResponse';

export const cancelSubscriptionDataSchema = z.object({
  success: z.boolean(),
  storeCancelled: z.boolean(),
  platform: z.string(),
});

export type ICancelSubscriptionData = z.infer<typeof cancelSubscriptionDataSchema>;

export const cancelSubscriptionResponseSchema = createApiResponseSchema(
  cancelSubscriptionDataSchema,
) as z.ZodSchema<IAPI<ICancelSubscriptionData>>;

export type ICancelSubscriptionResponse = IAPI<ICancelSubscriptionData>;
